import { UploadModule } from 'src/app/shared/modules/upload/upload.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PreOwnedOrdersRoutingModule } from './pre-owned-orders-routing.module';
import { ListingComponent } from './pages/listing/listing.component';
import { ViewComponent } from './pages/view/view.component';
import { DeleteMultipleComponent } from './components/delete-multiple/delete-multiple.component';
import { DeleteComponent } from './components/delete/delete.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PreOwnedOrdersChangeStatusComponent } from './components/pre-owned-orders-change-status/pre-owned-orders-change-status.component';
import { ChangeStatusComponent } from './components/change-status/change-status.component';
import { RefundOrderComponent } from './components/refund-order/refund-order.component';

@NgModule({
  declarations: [
    ListingComponent,
    ViewComponent,
    DeleteMultipleComponent,
    DeleteComponent,
    PreOwnedOrdersChangeStatusComponent,
    ChangeStatusComponent,
    RefundOrderComponent
  ],
  imports: [
    CommonModule,
    PreOwnedOrdersRoutingModule,
    SharedModule,
    UploadModule
  ]
})
export class PreOwnedOrdersModule { }
